/**
 * Segmento :mercado de /mercados/:mercado/:activo: "<idmercado>-<slug del nombre>"
 * (p.ej. 12-nasdaq-100). Sólo cuenta el id; el slug es decorativo y evita depender de
 * que los nombres sean únicos ('NASDAQ-100' y 'NASDAQ 100' dan el mismo slug).
 */
export function slugMercado(mercado: { idmercado: number | string; nombre?: string | null }): string {
    const slug = (mercado.nombre || '')
        .normalize('NFD').replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    return slug ? `${mercado.idmercado}-${slug}` : `${mercado.idmercado}`;
}

/** Href de /mercados para un activo. encodeURIComponent conserva isos como 'AAPL+'. */
export function urlMercado(mercado: { idmercado: number | string; nombre?: string | null }, iso: string): string {
    return `/mercados/${slugMercado(mercado)}/${encodeURIComponent(iso)}`;
}
